module.exports = __webpack_public_path__ + "img/img12.303d38ef.png";